export function calcRdi(
  bemessungslast,
  bohrkronendurchmesser,
  teilsicherheitsbeiwert,
  modellfaktor,
  qskiNumber,
  aNumber
) {
  let Rdi = 0.0;
  if (Number(qskiNumber) !== 0 && Number(bemessungslast) !== 0) {
    Rdi =
      (((Math.PI * (Number(bohrkronendurchmesser) + aNumber)) / 1_000) * qskiNumber) /
      (Number(teilsicherheitsbeiwert) * Number(modellfaktor));
  }
  return Rdi;
}

export function calcRdiDgruppe(
  bemessungslastGruppeGesamt,
  teilsicherheitsbeiwert,
  umfangErsatzpfahl,
  qskiNumber
) {
  let RdiDgruppe = 0.0;
  if (qskiNumber !== 0 && Number(bemessungslastGruppeGesamt) !== 0) {
    RdiDgruppe = (umfangErsatzpfahl * qskiNumber) / teilsicherheitsbeiwert;
  }
  return RdiDgruppe;
}

export function calcTi(vonNumber, bisNumber) {
  let Ti = Number.MAX_SAFE_INTEGER;

  if (bisNumber !== Number.MAX_SAFE_INTEGER && vonNumber !== Number.MAX_SAFE_INTEGER) {
    Ti = Math.abs(bisNumber - vonNumber);
  }
  return Ti;
}

export function calcLi(Rdi, Ti, pfahlneigungZurVertikalen, remainingBemessungslast) {
  let Li = 0.0;
  let condition = (Rdi * Ti) / Math.cos((Number(pfahlneigungZurVertikalen) * Math.PI) / 180);

  if (condition < remainingBemessungslast) {
    Li = Ti / Math.cos((Number(pfahlneigungZurVertikalen) * Math.PI) / 180);
  } else {
    if (remainingBemessungslast != 0) {
      Li = remainingBemessungslast / Rdi;
    }
  }

  return Li < 0.005 ? 0.0 : Li; //Wegen prüfung auf 0
}

export function calcRsdi(Rdi, Li) {
  return Rdi * Li;
}

export function calcTiBeta(Ti, pfahlneigungZurVertikalen) {
  if (Ti === Number.MAX_SAFE_INTEGER) {
    return Ti;
  }
  return Ti / Math.cos((pfahlneigungZurVertikalen * Math.PI) / 180);
}

export function calcRemainingBemessungslast(remainingBemessungslast, Li, Rdi) {
  return Number(remainingBemessungslast) - Number(Li) * Number(Rdi);
}

export function calcSumRsd(
  sumRsd,
  bohrkronendurchmesser,
  aNumber,
  Li,
  qskiNumber,
  teilsicherheitsbeiwert,
  modellfaktor
) {
  // result is in kN =>  mm * m * kN/mm² => divie result by 1000
  let ret = (sumRsd +=
    (Math.PI * (bohrkronendurchmesser + aNumber) * Li * qskiNumber) /
    (teilsicherheitsbeiwert * modellfaktor) /
    1000);
  return ret;
}

export function calcSumLi(sumLi, Li) {
  return sumLi + Li;
}

export function calcSumRsdi(sumRsdi, Rsdi) {
  return sumRsdi + Rsdi;
}
